module.exports = "<symbol id=\"thebestco-uikit-svg-Dot10\" viewBox=\"0 0 10 10\"><circle cx=\"5\" cy=\"5\" r=\"5\"/></symbol>";